import React from 'react'
import * as R from 'ramda'

import styles from './Description.module.scss'

export const Description = ({ text }) => (
  <div className={styles.descriptionContainer}>
    {R.addIndex(R.map)(
      ({ title, paragraphs }, index) => (
        <div className={styles.section} key={index}>
          {title ? <div className={styles.title}>{title}</div> : null}
          {paragraphs.map((par, index) => (
            <p className={styles.paragraph} key={index}>
              {par}
            </p>
          ))}
        </div>
      ),
      text,
    )}
  </div>
)
